import { render } from "./checkbox.vue?vue&type=template&id=ed87ce2a&scoped=true&ts=true"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"

import "./checkbox.vue?vue&type=style&index=0&id=ed87ce2a&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed87ce2a"]])

export default __exports__